import parseCookie from "./parseCookie";

const getCookieValue = (cookieName: string) => {
    if (typeof document === "undefined") return undefined;
    const parsedCookie = parseCookie(document.cookie);

    return parsedCookie[cookieName];
};

export default getCookieValue;
